// src/components/Common/LoadingSpinner.jsx

import React from "react";
import "../../styles/loading-spinner.css";

const LoadingSpinner = ({
  fullScreen = false,
  text = "Loading...",
  size = "medium",
}) => {
  const containerClass = fullScreen
    ? "loading-spinner-fullscreen"
    : "loading-spinner-container";
  const spinnerSize = {
    small: "30px",
    medium: "50px",
    large: "70px",
  };

  return (
    <div className={containerClass}>
      <div className="loading-spinner-wrapper">
        <div
          className="loading-spinner"
          style={{
            width: spinnerSize[size],
            height: spinnerSize[size],
          }}
        >
          <div className="loading-spinner-inner"></div>
        </div>
        <p className="loading-spinner-text">{text}</p>
        <div className="loading-spinner-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
